export function equalKeys(a: object, b: object) {
  const keyA = new Set(Object.keys(a));
  const keyB = new Set(Object.keys(b));

  return equalSet(keyA, keyB);
}

function equalSet(as: Set<string>, bs: Set<string>) {
  if (as.size !== bs.size) {
    return false;
  }
  for (const a of as) {
    if (!bs.has(a)) {
      return false;
    }
  }
  return true;
}
